import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { DiagnosticRating } from '@malou-io/package-utils';

export enum LoaderProgressSize {
    SM = 'small',
    MD = 'medium',
    LG = 'large',
}

export enum LoaderProgressColorClass {
    PRIMARY = 'bg-malou-primary',
    SUCCESS = 'bg-malou-green',
    WARNING = 'bg-malou-yellow',
    ERROR = 'bg-malou-pink',
}

@Component({
    selector: 'app-loader-progress',
    templateUrl: './loader-progress.component.html',
    styleUrls: ['./loader-progress.component.scss'],
    imports: [NgClass, MatButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderProgressComponent {
    readonly progress = input.required<number>();
    readonly loaderSize = input<LoaderProgressSize>(LoaderProgressSize.MD);
    readonly showPercentage = input<boolean>(true);
    readonly diagnosticRating = input<DiagnosticRating>(DiagnosticRating.BAD);

    readonly LoaderProgressSize = LoaderProgressSize;

    readonly height = computed(() => {
        switch (this.size()) {
            case LoaderProgressSize.SM:
                return '16px';
            case LoaderProgressSize.LG:
                return '24px';
            default:
                return '20px';
        }
    });
    readonly progressBarColorClass = computed(() => this.getProgressBarColorClass(this.diagnosticRating()));
    readonly progressPercentage = computed(() => (this.progress ? `${this.progress()}%` : '0%'));
    readonly size = signal(LoaderProgressSize.SM);

    getProgressBarColorClass = (totalScoreRating: DiagnosticRating): LoaderProgressColorClass => {
        if (totalScoreRating === DiagnosticRating.GOOD) {
            return LoaderProgressColorClass.SUCCESS;
        }

        if (totalScoreRating === DiagnosticRating.AVERAGE) {
            return LoaderProgressColorClass.WARNING;
        }

        return LoaderProgressColorClass.ERROR;
    };
}
